module.exports = __webpack_public_path__ + "img/20210731_144458.96d2868b.jpg";